"use strict";

class StationSettingsTuneInCtrl
{
    constructor($rootScope, $http, $mdToast, $scope, $mdDialog)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;

        this.custom_radiovis_fqdn = false;
        this.streams = {};
        this.modelTypes = {};

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.tuneinform.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        this.exportData = {
            tunein: {}
        };

        $rootScope.saveSettings = () => {
            this.save();
        };

        this.fetch();
    }

    fetch()
    {
        this.$http.get('/stationsettings/export/tunein').then(response => {

            this.exportData = response.data;

            if(!this.exportData.tunein.mappings) {
                this.exportData.tunein.mappings = [];
            }

        });

        this.$http.get('/stationsettings/exportinfo').then(response => {
            this.modelTypes = response.data.modelTypes;
        });

    }

    save()
    {
        this.$rootScope.saveDisabled = true;
        this.$http.put('/stationsettings/export', this.exportData).then(() => {

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=TuneIn', //@trans('labels.Export')
                hideDelay: 6000,
                position: ('top right')
            });

            this.$rootScope.saveDisabled = false;
        });
    }

    saveOne(name, key, data) {
        this.$rootScope.saveDisabled = true;
        data.last = new Date();

        let list = {};
        list[key] = data;
        this.$http.put('/stationsettings/export', list).then(() => {
            this.$rootScope.saveDisabled = false;
        });
    }

    getFieldValuesOfType(id) {
        let fields = {};
        angular.forEach(this.modelTypes, (modelType) => {
            if(modelType.id == id) {
                fields = modelType.fields;
            }
        });
        return fields;
    }

    onCloseModelTypeSelect(object) {
        if (object.title) {
            object.title = null;
        }
        if (object.artist) {
            object.artist = null;
        }
        if (object.album) {
            object.album = null;
        }
        if (object.label) {
            object.label = null;
        }
        if (object.art_url) {
            object.art_url = null;
        }
        if (object.target_url) {
            object.target_url = null;
        }
    }

    addNewMapping(index) {
        this.exportData[index].mappings.push({});
    }

    deleteMapping(exportName, index, ev) {

        ev.stopPropagation();

        this.$mdDialog.show( {

            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then( () => {

            this.exportData[exportName].mappings.splice(index, 1);
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=item&title='+exportName,
                hideDelay: 6000,
                position: ('top right')
            });
        });
    }

    showMusicFields(code) {
        return code == 'song' || code == undefined;
    }

}

StationSettingsTuneInCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$scope', '$mdDialog'];

module.exports = StationSettingsTuneInCtrl;